import { X } from 'lucide-react';
import {User} from "@/types/user";
import Avatar from "@/app/components/Avatar";

interface ProfileHeaderProps {
    user: User;
    onClose: () => void;
}

export function ProfileHeader({ user, onClose }: ProfileHeaderProps) {
    return (
        <div className="relative bg-gradient-to-br from-emerald-600 via-emerald-800 to-gray-900 p-6 shrink-0">
            <button onClick={onClose} className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors">
                <X size={20} />
            </button>
            <div className="flex items-center gap-4">
                <Avatar
                    src={user.avatar}
                    username={user.username}
                    className="w-14 h-14 sm:w-16 sm:h-16 rounded-full ring-2 ring-white/10"
                    fallbackClassName="bg-gray-900 text-xl"
                />
                <div>
                    <h2 className="text-2xl font-bold text-white">{user.username}</h2>
                    <p className="text-green-100/90 text-xs mt-0.5">
                        <span className="uppercase tracking-wide">{user.provider}</span> ID: <span className="font-mono tabular-nums">{user.provider_id}</span>
                    </p>
                </div>
            </div>
        </div>
    );
}